import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { swal, typeChecker } from "../../../utils/methods";
import { _post } from "../../../utils/network";

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb.component';
import FormField from "../../../components/Form/FormField/FormField.component";
import LoadingButton from '../../../components/LoadingButton/LoadingButton.component';

const MarketingCodesCreate = ({ componentType='create' }) => {
	const { t } = useTranslation();
	const { id } = useParams();
	const location = useLocation();
	const formRef = useRef(null);
	const breadcrumbItems = [
		{ title: t('dashboard'), link: '/dashboard' },
		{ title: t('marketing_codes'), link: '/marketing-codes-list' },
		{ title: t(componentType) }
	];
	const confirmSwal = statements => {
		swal(() => statements(), {
			text: t('are_you_sure_to_do_this'),
			confirmButtonText: t('yes'),
			cancelButtonText: t('no')
		});
	};

	const [createButtonIsLoading, setCreateButtonIsLoading] = useState(false);
	const createMarketingCode = async (event) => {
		event.preventDefault();
		if(createButtonIsLoading)
			return 0;
		let usersData = [];
		document.querySelectorAll('[data-form-field-multi-item="marketingCodeUserName"]').forEach(item => {
			let userID = item.querySelector('[data-form-field-multi-item-input="marketingCodeUserID"]').value.trim();
			if(!typeChecker(userID, 'uuid'))
				return toast.warn(t('select_user_correctly'));
			let commission = item.querySelector('[data-form-field-multi-item-input="marketingCodeCommission"]').value.trim();
			if(!typeChecker(commission, 'number'))
				return toast.warn(t('enter_commission_percentage_correctly'));
			usersData.push({
				user_id: userID,
				commission: commission
			});
		});
		let body = {
			code_id: id,
			users_list: usersData
		};
		confirmSwal(async () => {
			setCreateButtonIsLoading(true);
			let response = await _post('/codes/admin/' + (componentType === 'edit' ? 'editUsers' : componentType), body);
			setCreateButtonIsLoading(false);
			switch(response.code){
				case 200:
					toast.success(response[t('api_message')]);
					if(componentType === 'create')
						event.target.reset();
					break;
				default:
					toast.error(response[t('api_message')]);
			}
		});
	};

	const [marketingCode, setMarketingCode] = useState({});
	const getMarketingCode = async () => {
		let body = {
			code_id: id
		};
		let response = await _post('/codes/admin/getOne', body);
		switch(response.code){
			case 200:
				setMarketingCode({
					...response.data.code,
					users: response.data.users
				});
				break;
			default:
				toast.error(response[t('api_message')]);
		}
	};

	const marketingCodeUsersMultipleOptions = {
		keys: [
			"marketingCodeUserName",
			"marketingCodeUserID",
			"marketingCodeCommission"
		],
		titles: [
			t('user_name') + ' ' + t('and') + ' ' + t('national_id'),
			t('user_id'),
			t('commission_percentage')
		],
		foreignKey: {
			api: '/users/admin/getAll',
			body: {
				user_fullname: null,
				phone_number: null,
				national_code: null,
				trade_code: null,
				inviter_code: null,
				is_credit: null,
				is_active: null,
				page: 1,
				count: 10
			},
			response_key: 'users',
			key: 'user_id',
			title: ['user_fullname', 'national_code'],
			searchKey: 'user_fullname',
			searchTitle: t('user_name')
		},
		directions: ['rtl', 'lrt', 'ltr']
	};

	useEffect(() => {
		if(componentType === 'edit')
			getMarketingCode();
	}, [componentType]);

	useEffect(() => {
		if(componentType === 'create')
			formRef.current.reset();
	}, [location]);

	return (
		<>
			<Breadcrumb items={breadcrumbItems} />
			<div className="card mb-3">
				<div className="card-header">
					<h5 className="mb-0">{t(componentType)} {t('marketing_code')}</h5>
				</div>
				<div className="card-body bg-light">
					<form onSubmit={createMarketingCode} ref={formRef}>
						<div className="row gx-2">
							<FormField fieldKey="marketingCodeTitle" title={t('title')} value={marketingCode?.code_name} disabled ltr />
							<FormField type="toggle" fieldKey="marketingCodeIsActive" title={t('active')} value={marketingCode?.is_active} disabled />
							<FormField type="multi" fieldKey="marketingCodeUsers" title={t('users')} tip={t('max_search_result') + ': 10'} multiSettings={marketingCodeUsersMultipleOptions} value={JSON.stringify(marketingCode?.users?.map(user => user.user_fullname + ' - ' + user.national_code + ',' + user.user_id + ',' + user.code.commission))} />
						</div>
						<div>
							{componentType === 'create' ?
								<LoadingButton className="btn btn-primary d-inline-block mt-3 me-2" type="submit" name="create" isLoading={createButtonIsLoading}>
									<i className="fa fa-save"></i> {t('create')}
								</LoadingButton>
							:
								<LoadingButton className="btn btn-primary d-inline-block mt-3 me-2" type="submit" name="edit" isLoading={createButtonIsLoading}>
									<i className="fa fa-save"></i> {t('update')}
								</LoadingButton>
							}
						</div>
					</form>
				</div>
			</div>
		</>
	);
};

export default MarketingCodesCreate;
